import {
  hallowGreyCircle,
  hallowRedCircle,
  inProgressLate,
  redCross,
  greenV,
  hallowGreenCircle,
  solidGreenCircle,
  NA,
  UnallocatedNA,
  UnallocatedHallowGreyCircle,
  UnallocatedSolidGreenCircle,
} from "./constant";

export const findRCICTaskId = (taskDetails) => {
  const taskWithRCIC = taskDetails?.filter((item) => item?.AWMTaskID?.includes("RCIC"));
  return taskWithRCIC?.[0]?.AWMTaskID;
};
export const changeHandlingExportCSVFlags = (imageName, isSpecialProject = false) => {
  switch (imageName) {
    case "HallowGreyCircle":
      return hallowGreyCircle;

    case "HallowRedCircle":
      return hallowRedCircle;

    case "SolidRedCircle":
      return inProgressLate;

    case "RedCross":
      return redCross;

    case "GreenV":
      return greenV;

    case "HallowGreenCircle":
      return hallowGreenCircle;

    case "SolidGreenCircle":
      return solidGreenCircle;

    case "NA":
      if (isSpecialProject) {
        return UnallocatedNA;
      } else {
        return NA;
      }

    case "Awaiting":
      return UnallocatedHallowGreyCircle;

    case "In Progress":
      return UnallocatedSolidGreenCircle;

    case "Complete":
      return greenV;

    default:
      return imageName;
  }
};
export const cicImage = (imageName) => {
  switch (imageName) {
    case "HallowGreyCircle":
      return "pi pi-circle-off footerIconAll footerIcons7";

    case "HallowRedCircle":
      return "pi pi-circle-off footerIconAll footerIcons6";

    case "SolidRedCircle":
      return "pi pi-circle-on footerIconAll footerIcons9";

    case "RedCross":
      return "pi pi-times footerIconAll footerIcons4";

    case "GreenV":
      return "pi pi-check footerIconAll footerIcons3";

    case "HallowGreenCircle":
      return "pi pi-circle-off footerIconAll footerIcons5";

    case "SolidGreenCircle":
      return "pi pi-circle-on footerIconAll footerIcons8";

    case "Awaiting":
      return "pi pi-circle-off footerIconAll footerIcons7";

    case "In Progress":
      return "pi pi-circle-on footerIconAll footerIcons8";

    case "Complete":
      return "pi pi-check footerIconAll footerIcons3";

    case "NA":
      return "pi pi-ban footerIconAll footerIcons2"; // Using ban icon for NA

    default:
      return "";
  }
};
export const cicOptions = (option) => {
  switch (option) {
    case "HallowGreyCircle":
      return "Fullkit not ready, task start date > today";

    case "HallowRedCircle":
      return "Fullkit not ready, task start date =< today";

    case "SolidRedCircle":
      return "In-progress - late";

    case "RedCross":
      return "Job rejected - until Change Handling is initiated";

    case "GreenV":
      return "Job completed";

    case "HallowGreenCircle":
      return "Fullkit ready";

    case "SolidGreenCircle":
      return "In-progress (fullkit was already ready)";

    case "Awaiting":
      return "Stage not started";

    case "In Progress":
      return "Stage in progress";

    case "Complete":
      return "Job completed";

    case "NA":
      return NA;

    default:
      return option;
  }
};